// extracted by mini-css-extract-plugin
export default {"container":"yxLTkmWNUl8kp5ikWPTp","actions":"HA3OXCk48jXL4BsdvTW0","pdfContainer":"wihJMmYW9KoEkY9Zhh9M","header":"M5JwpkUo1ONwsu4dyeQV","viewer":"UAUHfDXS4SIrhciZQmNG"};